
<template>
    <content menu="多维实践平台" :childmenus="childmenus" @childMenuChange = "childMenuChange" :location = "location"> 
        <imageList :path = "path" :count="count"></imageList>	
    </content>
</template>


<script>
import content from './content.vue'
import imageList from "../exhibition/image_list.vue"
    export default {
        name:"ApplicationForm",
        components:{
            content,
            imageList
        },
        props:{
        },
        data() {
            return {
                path:'awards_condition/01/',
                count:16,
                childmenus:[
				{
					name:"“布丝瑰”女大学生民族手工艺研学基地",
					path:'practice_platform/01/',
					count:9
				},
				{
					name:"三维数字化全产业链云数据应用”政产学研用协同创新基地" ,
					path:'practice_platform/02/',
					count:7
				},
				{
					name:"乌审旗文化和旅游局高等专业技术人才委培基地",
					path:'practice_platform/03/',
					count:1
				},
				{
					name:"蒙古族服装造型与工艺实验教学示范中心",
					path:'practice_platform/04/',
					count:3
				},
				{
					name:"工业设计中心",
					path:'practice_platform/05/',
					count:1
				},
				{
					name:"皮革造型艺术产业化示范基地",
					path:'practice_platform/06/',
					count:1
				},
				{
					name:"虚拟仿真综合艺术实验教学示范中心",
					path:'practice_platform/07/',
					count:1
				},
				{
					name:"多媒体数字艺术基地",
					path:'practice_platform/08/',
					count:1
				}
                ],
				location:['多维实践平台'],
            };
        },
        methods:{
            childMenuChange(index){
                this.path = this.childmenus[index].path;
                this.count = this.childmenus[index].count;

				this.location = [];
				this.location.push('多维实践平台');
				this.location.push(this.childmenus[index].name);
            }
        },
        created() {
            this.path = this.childmenus[0].path;
            this.count = this.childmenus[0].count;
        }
    }
</script>

<style lang="scss" scoped>
</style>
